import React from 'react';
import { MonthsMap, Prices, buildMonthsMap } from '@features/price-graph';

export const useMonthsPricesMap = (prices: Prices): MonthsMap => {
	return React.useMemo(() => buildMonthsMap(prices), [prices]);
};
